import React from 'react'

type RedAsteriskProps = {
  className?: string
}

const RedAsterisk: React.FC<RedAsteriskProps> = (props) => {
  return <span className={`color-red-6 ${props.className ?? ''}`}>*</span>
}

export default RedAsterisk
